// extracted by mini-css-extract-plugin
export var form = "_c6-0";